import { identityService } from "../profile/identityService_v2.js";
import { matchService } from "./matchService_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { colors } from "../colors_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { dasModal } from "../modal_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { matchCard } from "./matchCard_v2.js";
import { action } from "../game/action_v2.js";

var recentMatchesState = {
  size: "small",
  filters: {
    playerFilter: true, //default
    watcherFilter: false,
    ownerFilter: false,
    activeFilter: true, //default
    finishedFilter: false,
  },
  page: 0,
  itemsOnPage: 5,
  totalPages: 1,
};

const getSize = () => {
  return recentMatchesState.size;
};

//always in the dom:
const recentMatchesNav = document.getElementById("recentMatchesNav");

const render = (size) => {
  recentMatchesNav.classList.add("sectionNarrow");

  const recentMatchesSection = document.getElementById("recentMatchesSection");
  switch (size) {
    case "normal":
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "modalBehinderCloseRecentMatches";
      recentMatchesState.size = "normal";
      recentMatchesSection.style.width = utilsApp.calculateSectionWidth();
      const htmlNormal = `
          <div id="sectionHeaderArea" class="vertical">
            <div id="ymMenu" class="menu">Recent Matches</div>
          </div>
          <div id="rmRightSide">
            <div id="ymBottomRow">
              <div id="showMatchesWhere"><h4>Recent Matches</h4></div>
              <div class="listControl flexRowWrap" id="recentMatches">
                  <ul class="noWrap font15" id="activeMatchesUL">
                    <li>Loading...</li>
                  </ul>
              </div>
            </div>
          </div>
          <div id="closeRecentMatches" class="x"></div>
      `;
      recentMatchesSection.innerHTML = htmlNormal;
      recentMatchesSection.classList.add("sectionWide");
      renderRecentMatches();
      colors.setButtonColors();
      if (document.body.contains(document.getElementById("copied"))) {
        document.getElementById("copied").classList.add("hide");
      }
      utilsApp.adjust4Mobile();
      break;
    case "small":
      recentMatchesSection.style.width = "0px";
      recentMatchesSection.innerHTML = "";
      recentMatchesSection.className = "";
      recentMatchesState.size = "small";
      break;
    default:
      console.log(
        "Error: Attempting to render yourMatches to invalid size: " + size,
      );
      return;
  }
  colors.setNavColors();

  recentMatchesSection.style.borderColor = colors.getGameColor("hexGrid");
  recentMatchesNav.style.borderColor = colors.getGameColor("hexGrid");
};

const close = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const handleYourMatchClick = () => {
  switch (getSize()) {
    case "small":
      render("normal");
      break;
    case "normal":
      render("small");
      break;
    default:
      render("small");
  }
};

const handleRecentMatchClick = async (event, element) => {
  const gotClicked = element.id;
  const matchID = gotClicked.slice(-7);
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  dasModal.render(`<div class="max">Loading...</div>`);
  await matchService.setCurrentMatchID(matchID);
  await matchService.refreshCurrentMatch(); // could have had updates we don't know about...
  dasModal.close();
  document.body.style.cursor = "default";
  close();
  scoreBoard.render();
  await board.render(); // and we are off
  action.renderSection();
};

const filterButtons = () => {
  return `
  <div id="filterButtonsRow" class="flexRow">
    <div id="rmfilterLeftColumn" class="flexColumn">
      <div id="participatingAsSplainer">
        You are:
      </div>
      <div id="participatingAsFilters" class="flexRowWrap">
        <div id="playerFilter" class="filterButtons">Player</div>
        <div id="watcherFilter" class="filterButtons">Watcher</div>
        <div id="ownerFilter" class="filterButtons">Owner</div>
      </div>
      <div class="filtersMessage" id="participatingAsFiltersMsg"></div>
    </div>
    <div id="filterAnd">and</div> 
    <div id="rmfilterRightColumn" class="flexColumn">
      <div id="matchSplainer">
        The match is:
      </div>
      <div id="matchStateFilters" class="flexRowWrap">
        <div id="activeFilter" class="filterButtons">Active</div>
        <div id="finishedFilter" class="filterButtons">Finished</div>
      </div>
      <div class="filtersMessage" id="matchFiltersMsg"></div>
    </div>
  </div>
  `;
};

const addFilterGroupStyling = () => {
  const rmfilterLeftColumn = document.getElementById("rmfilterLeftColumn");
  rmfilterLeftColumn.style.backgroundColor = colors.getGameColor("tip");
  const rmfilterRightColumn = document.getElementById("rmfilterRightColumn");
  rmfilterRightColumn.style.backgroundColor = colors.getGameColor("tip");
};

const handleFilterButtonClick = async (event, element) => {
  const gotClicked = element.id;
  if (
    ![
      "playerFilter",
      "watcherFilter",
      "ownerFilter",
      "activeFilter",
      "finishedFilter",
    ].includes(gotClicked)
  ) {
    return {
      status: 400,
      message: "this function does not handle elementL " + gotClicked,
    };
  }

  if (recentMatchesState.filters[gotClicked] === true) {
    recentMatchesState.filters[gotClicked] = false;
  } else {
    recentMatchesState.filters[gotClicked] = true;
  }
  colors.setButtonColors(); // update colors

  document.body.style.cursor = "wait";
  if (recentMatchesState.filters.finishedFilter === true) {
    dasModal.close();
    dasModal.render(`<div class="max">Loading...</div>`);
  }
  await matchService.loadMatches(recentMatchesState.filters);
  // when changing filters, what if they were on a page that
  // on longer exists after the new matches are loaded?
  // let's just start at zero
  recentMatchesState.page = 0;
  await renderRecentMatches(); // re-render the list
  dasModal.close();
  element.style.cursor = "default";
  document.body.style.cursor = "default";
  board.render();
  handleFilterMessages();
};

const handleFilterMessages = () => {
  if (
    recentMatchesState.filters.playerFilter === false &&
    recentMatchesState.filters.ownerFilter === false &&
    recentMatchesState.filters.watcherFilter === false
  ) {
    document.getElementById("participatingAsFiltersMsg").innerText =
      "Select at least one";
  } else {
    document.getElementById("participatingAsFiltersMsg").innerText = "";
  }

  if (
    recentMatchesState.filters.activeFilter === false &&
    recentMatchesState.filters.finishedFilter === false
  ) {
    document.getElementById("matchFiltersMsg").innerText =
      "Select at least one";
  } else {
    document.getElementById("matchFiltersMsg").innerText = "";
  }
};

const addMatchToArray = ({ match, matchesArray }) => {
  let alreadyThere = false;
  for (const matchInArray of matchesArray) {
    if (match.matchID === matchInArray.matchID) {
      alreadyThere = true;
    }
  }
  if (alreadyThere === false) {
    matchesArray.push(match);
  }
  return matchesArray;
};

/**
 * @brief This renders whatever matches are in matchState.cache
 * @returns
 */
const renderRecentMatches = async () => {
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  const currentMatchID =
    await matchService.getCurrentMatch().currentMatch.matchID;

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    document.body.style.cursor = "default";
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;

  const matches = matchService.getCache();
  let filteredMatches = [];
  if (matches.length > 0) {
    for (const match of matches) {
      // the filters decide if we render each row
      let passedPlayerOwnerWatcherFilter = false;
      let passedActiveFilter = false;
      let passedFinishedFilter = false;

      // start playerFilter
      if (recentMatchesState.filters.playerFilter === true) {
        if (pAUserID === match.p1UserID || pAUserID === match.p2UserID) {
          passedPlayerOwnerWatcherFilter = true;
        }
      } // end player filter

      // start watcherFilter
      if (recentMatchesState.filters.watcherFilter === true) {
        for (const watcherUserID of match.watchers || []) {
          if (pAUserID === watcherUserID) {
            passedPlayerOwnerWatcherFilter = true;
          }
        }
      } // end watch filter

      // start ownerFilter
      if (recentMatchesState.filters.ownerFilter === true) {
        if (pAUserID === match.ownerUserID) {
          passedPlayerOwnerWatcherFilter = true;
        }
      } // end owner filter

      // start activeFilter
      if (recentMatchesState.filters.activeFilter === true) {
        if (match.active === "active") {
          passedActiveFilter = true;
        }
      } // end active filter

      // start finishedFilter
      if (recentMatchesState.filters.finishedFilter === true) {
        if (match.active === "inActive") {
          passedFinishedFilter = true;
        }
      } // end finished filter

      if (
        passedPlayerOwnerWatcherFilter === true &&
        (passedActiveFilter === true || passedFinishedFilter === true)
      ) {
        filteredMatches = addMatchToArray({
          match,
          matchesArray: filteredMatches,
        }); // will prevent duplicates
      }
    } // end for match loop
  } //end match length >0

  // now that we have a list of playingAs matches filtered down..
  // we render them 5 at a time in pages

  const page = recentMatchesState.page;
  const itemsOnPage = recentMatchesState.itemsOnPage;
  const startIndex = page * itemsOnPage;
  let endIndex = filteredMatches.length;
  if (endIndex > startIndex + itemsOnPage) {
    endIndex = startIndex + itemsOnPage;
  }
  const totalPages = Math.ceil(filteredMatches.length / itemsOnPage);
  recentMatchesState.totalPages = totalPages;

  var matchItemsHTML = "";
  for (let i = startIndex; i < endIndex; i++) {
    matchItemsHTML =
      matchItemsHTML + matchCard.generateHTML(filteredMatches[i]);
  }
  const recentMatches = document.getElementById("recentMatches");
  recentMatches.innerHTML = `${filterButtons()}
      <div id="cardContainer">
        ${matchItemsHTML}
        <div id="showingMatches">
          <div class="prevNext" id="rmPrevious">Previous</div>
          <div class="prevNext" id="rmNext">Next</div> (Page ${page + 1} of ${totalPages})
        </div>
    </div>`;
  renderFilterButtonColors();
  addFilterGroupStyling();

  for (let i = startIndex; i < endIndex; i++) {
    const match = filteredMatches[i];
    const id = "recentMatch" + match.matchID;
    const matchCard = document.getElementById(id);
    if (document.body.contains(matchCard)) {
      if (currentMatchID != match.matchID) {
        eventHub.registerEvent("click", matchCard.id, handleRecentMatchClick);
        eventHub.registerEvent(
          "pointerover",
          matchCard.id,
          handleMatchRowPointerOver,
        );
        eventHub.registerEvent(
          "pointerout",
          matchCard.id,
          handleMatchRowPointerOut,
        );
        matchCard.style.backgroundColor = colors.getGameColor("tip");
      } else {
        matchCard.style.backgroundColor = colors.getGameColor("accent");
      }
    }
  }
  document.body.style.cursor = "default";
};

const handleMatchRowPointerOver = (event, element) => {
  document.getElementById(element.id).style.backgroundColor =
    colors.getGameColor("iPop");
};

const handleMatchRowPointerOut = (event, element) => {
  document.getElementById(element.id).style.backgroundColor =
    colors.getGameColor("tip");
};

const getFilter = (filter) => {
  switch (filter) {
    case "playerFilter":
      return recentMatchesState.filters[filter];
      break;
    case "watcherFilter":
      return recentMatchesState.filters[filter];
      break;
    case "ownerFilter":
      return recentMatchesState.filters[filter];
      break;
    case "activeFilter":
      return recentMatchesState.filters[filter];
      break;
    case "finishedFilter":
      return recentMatchesState.filters[filter];
      break;
  }
};

const renderFilterButtonColors = () => {
  const darkAccent = colors.getGameColor("darkAccent");
  const tip = colors.getGameColor("tip");

  const playerFilter = document.getElementById("playerFilter");
  if (getFilter("playerFilter") === true) {
    playerFilter.style.background = darkAccent;
    playerFilter.classList.add("boxshadow");
  } else {
    playerFilter.style.background = tip;
    playerFilter.classList.remove("boxshadow");
  }

  const watcherFilter = document.getElementById("watcherFilter");
  if (getFilter("watcherFilter") === true) {
    watcherFilter.style.background = darkAccent;
    watcherFilter.classList.add("boxshadow");
  } else {
    watcherFilter.style.background = tip;
    watcherFilter.classList.remove("boxshadow");
  }

  const ownerFilter = document.getElementById("ownerFilter");
  if (getFilter("ownerFilter") === true) {
    ownerFilter.style.background = darkAccent;
    ownerFilter.classList.add("boxshadow");
  } else {
    ownerFilter.style.background = tip;
    ownerFilter.classList.remove("boxshadow");
  }

  const activeFilter = document.getElementById("activeFilter");
  if (getFilter("activeFilter") === true) {
    activeFilter.style.background = darkAccent;
    activeFilter.classList.add("boxshadow");
  } else {
    activeFilter.style.background = tip;
    activeFilter.classList.remove("boxshadow");
  }

  const finishedFilter = document.getElementById("finishedFilter");
  if (getFilter("finishedFilter") === true) {
    finishedFilter.style.background = darkAccent;
    finishedFilter.classList.add("boxshadow");
  } else {
    finishedFilter.style.background = tip;
    finishedFilter.classList.remove("boxshadow");
  }
};

const handleFilterPointerOver = (event, element) => {
  element.classList.add("shadow");
  element.style.background = colors.getGameColor("iPop");
};

const handlePointerOutPrevNext = (event, element) => {
  element.classList.remove("shadow");
  element.style.background = colors.getGameColor("lighterAccent");
};

const handleClickPrevNext = (event, element) => {
  const gotClicked = element.id;
  if (
    gotClicked === "rmNext" &&
    recentMatchesState.page < recentMatchesState.totalPages - 1
  ) {
    recentMatchesState.page++;
  }
  if (gotClicked === "rmPrevious" && recentMatchesState.page > 0) {
    recentMatchesState.page--;
  }
  renderRecentMatches();
};

// {
//     playerFilter: true, //default
//     watcherFilter: false,
//     ownerFilter: false,
//     activeFilter: true, //default
//     finishedFilter: false,
//   }

const numMatches = async () => {
  let count = 0;
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAUserID = pAIdentityResponse.identity.userID;
  for (const match of matchService.getCache()) {
    let countPWO = false;
    let countActive = false;
    if (
      recentMatchesState.filters.playerFilter &&
      (match.p1UserID === pAUserID || match.p2UserID === pAUserID)
    ) {
      countPWO = true;
    }
    if (
      recentMatchesState.filters.watcherFilter &&
      match.watchers?.includes(pAUserID)
    ) {
      countPWO = true;
    }
    if (
      recentMatchesState.filters.ownerFilter &&
      match.ownerUserID === pAUserID
    ) {
      countPWO = true;
    }
    if (recentMatchesState.filters.activeFilter && match.active === "active") {
      countActive = true;
    }
    if (
      recentMatchesState.filters.finishedFilter &&
      match.active === "inActive"
    ) {
      countActive = true;
    }
    if (countPWO & countActive) {
      count++;
    }
  }
  return count;
};

eventHub.registerEvent("click", "modalBehinderCloseRecentMatches", close);
eventHub.registerEvent("click", "closeRecentMatches", close);
eventHub.registerEvent("click", "recentMatchesNav", handleYourMatchClick);

eventHub.registerEvent("click", "playerFilter", handleFilterButtonClick);
eventHub.registerEvent("pointerout", "playerFilter", renderFilterButtonColors);
eventHub.registerEvent("pointerover", "playerFilter", handleFilterPointerOver);

eventHub.registerEvent("click", "watcherFilter", handleFilterButtonClick);
eventHub.registerEvent("pointerout", "watcherFilter", renderFilterButtonColors);
eventHub.registerEvent("pointerover", "watcherFilter", handleFilterPointerOver);

eventHub.registerEvent("click", "ownerFilter", handleFilterButtonClick);
eventHub.registerEvent("pointerout", "ownerFilter", renderFilterButtonColors);
eventHub.registerEvent("pointerover", "ownerFilter", handleFilterPointerOver);

eventHub.registerEvent("click", "activeFilter", handleFilterButtonClick);
eventHub.registerEvent("pointerout", "activeFilter", renderFilterButtonColors);
eventHub.registerEvent("pointerover", "activeFilter", handleFilterPointerOver);

eventHub.registerEvent("click", "finishedFilter", handleFilterButtonClick);
eventHub.registerEvent(
  "pointerout",
  "finishedFilter",
  renderFilterButtonColors,
);
eventHub.registerEvent(
  "pointerover",
  "finishedFilter",
  handleFilterPointerOver,
);

eventHub.registerEvent("pointerover", "rmPrevious", handleFilterPointerOver);
eventHub.registerEvent("pointerout", "rmPrevious", handlePointerOutPrevNext);
eventHub.registerEvent("click", "rmPrevious", handleClickPrevNext);

eventHub.registerEvent("pointerover", "rmNext", handleFilterPointerOver);
eventHub.registerEvent("pointerout", "rmNext", handlePointerOutPrevNext);
eventHub.registerEvent("click", "rmNext", handleClickPrevNext);

export const recentMatches = {
  render,
  getSize,
  getFilter,
  numMatches,
};
